export const imageApi = 'http://image.karrot.pl/'
export const logo = 'kawiarnia__karrot__logo.png'
export const fb_image = 'kawiarnia__karrot__kawaikultura_fb.png'



// WEBPACK FOOTER //
// ./src/config.js